import { redirect } from "@client/actions";
import { makeRedirectToSelector } from "@client/content/selectors";
import { type BaseAppState, type EntityRef } from "@client/types";
import { type Dispatch } from "react";

export const goTo =
  (target: string, ref: EntityRef, prefix?: string) => (dispatch: Dispatch<any>, getState: () => BaseAppState) => {
    const redirectTo = makeRedirectToSelector(target, prefix)(getState(), ref);
    if (redirectTo) {
      dispatch(
        redirect({
          redirectTo
        })
      );
    }
  };
